/**
 * Teaser Result — 명반 미리보기 렌더 + 결제 연결
 *
 * 데이터는 App Proxy(/apps/saju/teaser/:id)에서 JSON으로만 받는다.
 * 여기서 새로 판정하는 것은 계절관계·오행 개수·월운뿐이고,
 * 用神·身強弱·十神·大運·神煞은 서버가 준 값을 그대로 쓴다.
 * 티저가 자체 판정하면 결제 후 결과지와 다른 답이 나온다.
 *
 * ⚠️ 고객이 입력한 값(이름 등)은 반드시 textContent 로 넣는다.
 *    innerHTML 을 쓰면 이름 칸에 넣은 스크립트가 실행된다 (XSS).
 *
 * ?preview=1 을 붙이면 서버를 호출하지 않고 샘플 값으로 그린다.
 * 배포 전에 사본 테마에서 디자인·모바일만 먼저 볼 때 쓴다.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-teaser-root]');
  if (!root) return;

  var D = window.TEASER_DATA;

  var elLoading = root.querySelector('[data-teaser-loading]');
  var elError   = root.querySelector('[data-teaser-error]');
  var elContent = root.querySelector('[data-teaser-content]');

  var COLS = ['year', 'month', 'day', 'hour'];
  var FIVE_ORDER = ['木', '火', '土', '金', '水'];
  var FIVE_LABEL_COLOR = { 木: '#8fbf8f', 火: '#c98a8a', 土: '#c9a35e', 金: '#d8ccf0', 水: '#8fa8c9' };
  var FIVE_FILL_COLOR  = { 木: '#4e7a4e', 火: '#8a4a4a', 土: '#8a7440', 金: '#8f87a8', 水: '#42618a' };
  var MONTH_BRANCH_ORDER = ['寅', '卯', '辰', '巳', '午', '未', '申', '酉', '戌', '亥', '子', '丑'];

  // 결제에 필요한 값 — 조회 성공 시 채워진다
  var variantId = '';
  var properties = {};
  var teaserId = '';
  var productType = '';

  var params = new URLSearchParams(window.location.search);
  teaserId = params.get('id') || '';

  if (!D) {
    console.error('[teaser] teaser-data.js 가 로드되지 않았다');
    showError();
    return;
  }

  if (params.get('preview') === '1') {
    render(sampleData());
    return;
  }

  if (!teaserId) {
    showError();
    return;
  }

  fetch('/apps/saju/teaser/' + encodeURIComponent(teaserId), {
    headers: { Accept: 'application/json' }
  })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      if (!data || !data.ok) throw new Error('조회 실패');

      variantId   = data.variantId || '';
      properties  = data.input || {};
      productType = data.productType || '';

      // 만세력 계산이 실패한 경우에도 결제로는 갈 수 있어야 한다
      if (data.status !== 'ready' || !data.saju) {
        showError();
        return;
      }

      render(data);
    })
    .catch(function (err) {
      console.error('[teaser] 조회 실패', err);
      showError();
    });

  // ─── 렌더 ────────────────────────────────────────────────────────────────

  function render(data) {
    var input   = data.input || {};
    var saju    = data.saju || {};
    var pillars = saju.pillars || {};

    var hourUnknown = isHourUnknown(input['出生時辰']);

    var dayHanja  = (pillars.day && pillars.day.hanja) || '';
    var dayStem   = dayHanja.charAt(0);
    var dayBranch = dayHanja.charAt(1);
    var dayElem   = D.STEM_ELEMENT[dayStem] || '';

    renderHero(input);
    renderBirthLine(input, pillars, hourUnknown, data.name || input['姓名'] || '');
    renderDeclare(dayStem, dayElem, pillars);
    renderTable(pillars, saju.sinsalPos || {}, hourUnknown);
    renderFive(pillars, hourUnknown);
    renderSide(saju);
    renderFace(input);
    renderConflict(input);
    renderBalance(pillars, saju, hourUnknown);
    renderPeach(saju, hourUnknown);
    renderMonths(dayStem, dayBranch, dayElem, input, saju);
    renderHourNotes(hourUnknown);

    hide(elLoading);
    show(elContent);
  }

  // ─── 2. HERO ────────────────────────────────────────────────────────────

  /**
   * 성별에 맞는 얼굴만 남긴다.
   *
   * Liquid 가 남·여 이미지를 둘 다 그려 뒀다 (섹션 파일의 HERO 주석 참조).
   * 페이지가 그려지는 시점에는 성별을 알 수 없어서 두 장을 다 받아 두고,
   * 데이터가 도착한 지금 쓰지 않는 쪽을 지운다.
   *
   * 이 함수는 show(elContent) 보다 먼저 돌기 때문에 고객 눈에 두 장이
   * 함께 보이는 순간은 없다.
   *
   * 性別 은 폼(birth-form.liquid)에서 항상 男/女 로 오지만,
   * 값이 없거나 예상 밖이면 지금까지의 화면과 같게 남성으로 둔다.
   */
  function renderHero(input) {
    var keep = input['性別'] === '女' ? '女' : '男';
    var imgs = root.querySelectorAll('[data-teaser-hero]');

    for (var i = 0; i < imgs.length; i++) {
      if (imgs[i].getAttribute('data-teaser-hero') !== keep) {
        imgs[i].parentNode.removeChild(imgs[i]);
      }
    }
  }

  // ─── 3. 명조 바 ──────────────────────────────────────────────────────────

  function renderBirthLine(input, pillars, hourUnknown, name) {
    var parts = [];

    // 이름을 맨 앞에 둔다. 자기 이름이 보이는 순간 "내 것"이라는 체감이 확 올라간다.
    // 시안 명조 바에는 없던 항목이지만 한 줄 안에서 끝나 구조는 그대로다.
    if (name) parts.push(name);

    // 曆法은 화면에 그릴 때만 바꿔 보여준다 (陰曆 → 農曆).
    // 🔴 input 을 고쳐 쓰면 안 된다. 이 객체는 결제 때 장바구니로 그대로 넘어가고,
    //    서버가 "陰曆" 글자를 그대로 비교해 음력/양력을 가른다.
    //    여기서 덮어쓰면 음력 고객의 사주가 통째로 틀린다. 읽기만 한다.
    if (input['曆法']) {
      parts.push(D.CALENDAR_LABEL[input['曆法']] || input['曆法']);
    }

    var date = formatBirthDate(input['出生日期'] || '');
    if (date) parts.push(date);

    // 시진은 입력한 숫자가 아니라 엔진이 낸 時柱의 지지에서 뽑는다.
    // 그래야 바로 아래 사주표와 어긋나지 않는다.
    if (!hourUnknown) {
      var hourBranch = ((pillars.hour && pillars.hour.hanja) || '').charAt(1);
      if (hourBranch) parts.push(hourBranch + '時');
    }

    var line = parts.join(' ');
    if (input['性別']) {
      line += ' · ' + (input['性別'] === '女' ? '坤命' : '乾命');
    }

    setText('[data-teaser-birth]', line);
  }

  function formatBirthDate(raw) {
    var m = String(raw).match(/^(\d{4})\D+(\d{1,2})\D+(\d{1,2})/);
    if (!m) return String(raw);
    return m[1] + '年 ' + Number(m[2]) + '月 ' + Number(m[3]) + '日';
  }

  // ─── 4~5. 일간 선언 + 한 줄 ─────────────────────────────────────────────

  function renderDeclare(dayStem, dayElem, pillars) {
    var monthBranch = ((pillars.month && pillars.month.hanja) || '').charAt(1);
    var season = D.BRANCH_SEASON[monthBranch] || '';
    var seasonElem = D.SEASON_ELEMENT[season] || '';

    setText('[data-teaser-daymaster]', dayStem + dayElem);
    setText('[data-teaser-season]', season);
    setText('[data-teaser-relation]', seasonRelation(dayElem, seasonElem));

    var byStem = D.STEM_SEASON_LINE[dayStem];
    setText('[data-teaser-persona]', (byStem && byStem[season]) || '');
  }

  /**
   * 계절 세력과 일간의 관계. 20종 전부 여기서 나온다.
   * ⚠️ 여기서 "弱"을 쓰지 않는다. 계절 세력과 억부 강약은 다른 층이다.
   *    강약은 표 옆의 身強/身弱 배지가 따로 말한다.
   */
  function seasonRelation(dayElem, seasonElem) {
    if (!dayElem || !seasonElem) return '';
    if (dayElem === seasonElem) return dayElem + '旺';
    if (D.GENERATES[dayElem] === seasonElem) return seasonElem + '旺洩' + dayElem;
    if (D.CONTROLS[seasonElem] === dayElem) return seasonElem + '旺剋' + dayElem;
    if (D.CONTROLS[dayElem] === seasonElem) return seasonElem + '旺耗' + dayElem;
    if (D.GENERATES[seasonElem] === dayElem) return seasonElem + '旺生' + dayElem;
    return seasonElem + '旺';
  }

  // ─── 6. 四柱原局 표 ──────────────────────────────────────────────────────

  function renderTable(pillars, sinsalPos, hourUnknown) {
    // 🔴 이 세 사전은 나중에 추가된 키라 「teaser.js 는 새 버전인데 teaser-data.js 는
    //    옛 버전」인 순간에 undefined 가 된다. 무방비로 쓰면 undefined['丙'] 로 throw 하고,
    //    renderTable 은 렌더 시퀀스 중간이라 show(elContent) 에 도달하지 못해
    //    티저 페이지가 통째로 로딩에서 멈춘다 — CTA·결제 버튼까지 포함해서.
    //    (파일의 다른 D.X 참조들은 두 파일이 다 옛 버전이어도 존재하는 키라 같은 위험이 없다.)
    var KR_STEM   = D.STEM_KR     || {};
    var KR_BRANCH = D.BRANCH_KR   || {};
    var KR_SIP    = D.SIPSEONG_KR || {};

    COLS.forEach(function (col) {
      var blank = hourUnknown && col === 'hour';
      var p = pillars[col] || {};
      var hanja = p.hanja || '';
      var stem = hanja.charAt(0);
      var branch = hanja.charAt(1);

      // 한글이 큰 글자(주역), 한자가 작은 글자(근거)다.
      // 한자는 간지+오행을 붙여 쓴다 — 丙火·午火 는 명리에서 원래 붙여 쓰는 관용 표기다.
      // 사전에 없으면 빈 문자열로 떨어뜨린다. undefined 가 화면에 나가면 안 된다
      // (서버 sipseongToHanja 는 변환 실패 시 한국어 원본을 그대로 돌려준다).
      setText('[data-teaser-stem-kr="' + col + '"]',   blank ? '' : (KR_STEM[stem] || ''));
      setText('[data-teaser-stem="' + col + '"]',      blank ? D.TEXT.dash : stem + (p.stemElement || ''));
      setText('[data-teaser-branch-kr="' + col + '"]', blank ? '' : (KR_BRANCH[branch] || ''));
      setText('[data-teaser-branch="' + col + '"]',    blank ? D.TEXT.dash : branch + (p.branchElement || ''));

      // 日柱 칸은 십신 대신 日主를 쓴다 (시안 그대로)
      var sipseong = col === 'day' ? '日主' : (p.stemSipseong || D.TEXT.dash);
      setText('[data-teaser-sipseong-kr="' + col + '"]', blank ? '' : (KR_SIP[sipseong] || ''));
      setText('[data-teaser-sipseong="' + col + '"]',    blank ? D.TEXT.dash : sipseong);

      // 神煞 — 있는 칸만 잠금 바, 없으면 "—"
      // ⚠️ 시간 미제공이면 잠금 바를 쓰지 않는다. 잠금 바는 "계산됐지만 유료"라는 뜻인데
      //    시주는 계산 자체가 안 되므로, 결제해도 안 나오는 것을 잠긴 것처럼 보이면 안 된다.
      var cell = root.querySelector('[data-teaser-sinsal="' + col + '"]');
      if (!cell) return;
      clear(cell);
      if (!blank && sinsalPos[col]) {
        cell.appendChild(makeLock('teaser-lock teaser-lock--xs'));
      } else {
        cell.textContent = D.TEXT.dash;
      }
    });
  }

  // ─── 7. 오행 막대 ────────────────────────────────────────────────────────

  /**
   * 8글자(시간 미제공이면 6글자) 단순 집계.
   * 엔진의 five 는 지장간까지 반영한 소수 가중치라 화면의 정수 칸과 맞지 않는다.
   */
  function countFive(pillars, hourUnknown) {
    var counts = { 木: 0, 火: 0, 土: 0, 金: 0, 水: 0 };
    COLS.forEach(function (col) {
      if (hourUnknown && col === 'hour') return;
      var hanja = (pillars[col] && pillars[col].hanja) || '';
      var s = D.STEM_ELEMENT[hanja.charAt(0)];
      var b = D.BRANCH_ELEMENT[hanja.charAt(1)];
      if (s) counts[s] += 1;
      if (b) counts[b] += 1;
    });
    return counts;
  }

  function renderFive(pillars, hourUnknown) {
    var box = root.querySelector('[data-teaser-five]');
    if (!box) return;
    clear(box);

    var counts = countFive(pillars, hourUnknown);

    FIVE_ORDER.forEach(function (elem) {
      var count = counts[elem] || 0;

      var row = el('div', 'teaser-five__row');

      var label = el('span', 'teaser-five__label');
      label.textContent = elem;
      label.style.color = FIVE_LABEL_COLOR[elem];

      var track = el('span', 'teaser-five__track');
      var fill = el('span', 'teaser-five__fill');
      fill.style.width = Math.min(100, count * 20) + '%';
      fill.style.background = FIVE_FILL_COLOR[elem];
      track.appendChild(fill);

      var value = el('span', 'teaser-five__count');
      value.textContent = String(count);

      row.appendChild(label);
      row.appendChild(track);
      row.appendChild(value);
      box.appendChild(row);
    });
  }

  // 강약 라벨 — 아는 값만 쓰고 모르는 값은 비운다.
  // ⚠️ 만세력은 "balanced"도 준다. 예전처럼 strong이 아니면 전부 身弱으로 떨어뜨리면
  //    균형 사주 고객에게 "약한 사주"라고 잘못 안내하게 된다 (2026-08-13 검증에서 확인).
  //    서버 public/js/result.js · functions/src/utils/mapping.ts 와 같은 값을 유지할 것.
  var STRENGTH_LABEL = { strong: '身強', weak: '身弱', balanced: '中和' };

  function renderSide(saju) {
    setText('[data-teaser-strength]', STRENGTH_LABEL[saju.strength] || '');
    setText('[data-teaser-bigluck]', currentBigLuck(saju.bigLuck || []));
  }

  /**
   * 올해가 들어 있는 대운 구간을 고른다.
   * yearRange("2017–2026")로 판정하므로 만 나이/세는 나이를 따질 필요가 없다.
   */
  function currentBigLuck(list) {
    var thisYear = new Date().getFullYear();
    for (var i = 0; i < list.length; i++) {
      var m = String(list[i].yearRange || '').match(/(\d{4})\D+(\d{4})/);
      if (m && thisYear >= Number(m[1]) && thisYear <= Number(m[2])) return list[i].pillar || '';
    }
    return list.length ? (list[list.length - 1].pillar || '') : '';
  }

  // ─── 8. 관상 7카드 ───────────────────────────────────────────────────────

  function renderFace(input) {
    var box = root.querySelector('[data-teaser-face]');
    if (!box) return;
    clear(box);

    D.FACE_PARTS.forEach(function (part, index) {
      var picked = input[part.key] || '';
      var copy = (D.FACE_COPY[part.key] || {})[picked];

      var card = el('div', 'teaser-face__card' + (index === 6 ? ' teaser-face__card--wide' : ''));

      var head = el('p', 'teaser-face__part');
      head.textContent = (part.label || part.key) + ' · ' + part.palace;

      var pick = el('p', 'teaser-face__pick');
      pick.textContent = copy ? copy.text : picked;

      var line = el('p', 'teaser-face__line');
      line.textContent = copy ? copy.line : '';

      card.appendChild(head);
      card.appendChild(pick);
      card.appendChild(line);
      box.appendChild(card);
    });
  }

  // ─── 9. 七處 충돌 ────────────────────────────────────────────────────────

  function renderConflict(input) {
    var box = root.querySelector('[data-teaser-conflict]');
    if (!box) return;
    clear(box);

    var hit = null;
    for (var i = 0; i < D.FACE_CONFLICTS.length; i++) {
      var c = D.FACE_CONFLICTS[i];
      if (input[c.a[0]] === c.a[1] && input[c.b[0]] === c.b[1]) { hit = c; break; }
    }

    if (!hit) {
      box.textContent = D.TEXT.conflictNone;
      return;
    }

    // 부위명은 둘 다 잠근다 — 하나만 가리면 나머지로 추측이 된다
    box.appendChild(document.createTextNode('七處之中，'));
    box.appendChild(makeLock('teaser-lock teaser-lock--sm'));
    box.appendChild(document.createTextNode(' 與 '));
    box.appendChild(makeLock('teaser-lock teaser-lock--sm'));
    box.appendChild(document.createTextNode(' 相衝。'));
  }

  // ─── 10. 桃花指數 ────────────────────────────────────────────────────────

  function renderPeach(saju, hourUnknown) {
    var dohwa = saju.dohwa || {};
    // 시간을 모르는데 확실한 세 주에도 도화가 없으면, 도화가 시주에 있을 수 있다.
    // 이때는 잠그지 않고 "미확정"으로 말한다. 결제해도 안 나오는 것을 잠그면 안 된다.
    var pending = hourUnknown && !dohwa.present;

    toggle('[data-teaser-peach-locked]', !pending);
    toggle('[data-teaser-peach-pending]', pending);

    if (pending) {
      setText('[data-teaser-peach-pending-title]', D.TEXT.dohwaPendingTitle);
      setText('[data-teaser-peach-pending-body]', D.TEXT.dohwaPendingBody);
    }

    // 결제 블록의 桃花分析 행 (결과지 섹션명과 같은 말을 쓴다)
    toggle('[data-teaser-peach-row-lock]', !pending);
    toggle('[data-teaser-peach-row-need]', pending);
    if (pending) setText('[data-teaser-peach-row-need]', D.TEXT.dohwaNeedHour);
  }

  // ─── 11. 오행균형 ────────────────────────────────────────────────────────

  /**
   * 조건과 잠금값을 모두 用神 기준으로 맞춘다.
   * 用神은 엔진 값을 그대로 받으므로 결제 후 개운 파트(색·방위)와 어긋나지 않는다.
   */
  function renderBalance(pillars, saju, hourUnknown) {
    var counts = countFive(pillars, hourUnknown);
    var need = (saju.yongshin && saju.yongshin.primary) || '';
    var needCount = need ? (counts[need] || 0) : 0;

    var lines = needCount <= 1 ? D.TEXT.balanceLow : D.TEXT.balanceEnough;
    setText('[data-teaser-balance-1]', lines[0]);
    setText('[data-teaser-balance-2]', lines[1]);
    setText('[data-teaser-balance-3]', lines[2]);
  }

  // ─── 12. 未來十二個月 ────────────────────────────────────────────────────

  function renderMonths(dayStem, dayBranch, dayElem, input, saju) {
    var ctx = {
      dayBranch: dayBranch,
      dayElem: dayElem,
      isFemale: input['性別'] === '女',
      peach: peachBranchOf(dayBranch),
      luckBranch: currentBigLuck(saju.bigLuck || []).charAt(1),
      // 문장 뱅크를 고르는 씨앗. 일주를 섞어야 같은 달이 걸린 다른 사람에게
      // 같은 문장이 나오지 않는다. 같은 사람은 언제 봐도 같은 문장이다.
      seed: charSum(dayStem + dayBranch)
    };

    var months = buildMonths(ctx);
    var connected = months.filter(function (m) {
      return D.CONNECTED_KEYWORDS.indexOf(m.keyword) !== -1;
    });

    renderConnectedCount(connected.length);
    renderMonthCards(connected, months);
  }

  /** 이번 달 포함 12개월 */
  function buildMonths(ctx) {
    var now = new Date();
    var out = [];
    for (var i = 0; i < 12; i++) {
      var d = new Date(now.getFullYear(), now.getMonth() + i, 1);
      var y = d.getFullYear();
      var m = d.getMonth() + 1;
      var mp = monthPillar(y, m);
      var keyword = monthKeyword(mp, ctx);
      out.push({
        year: y,
        month: m,
        keyword: keyword,
        stars: D.KEYWORD_STARS[keyword] || 1,
        line: pickLine(keyword, y, m, ctx.seed)
      });
    }
    return out;
  }

  /**
   * 월주 — 五虎遁으로 계산한다.
   * ⚠️ 절기 경계는 근사다. 사주의 월은 양력 1일이 아니라 절기(입춘·경칩…)에 바뀐다.
   *    양력 초순생은 한 칸 어긋날 수 있다. 만세력 API가 절기를 주는지 확인되지 않았다.
   */
  function monthPillar(gYear, gMonth) {
    var branchIdx = (gMonth + 10) % 12;                  // 0 = 寅月
    var ganzhiYear = gMonth === 1 ? gYear - 1 : gYear;   // 丑月(1월)은 전년 간지에 속한다
    var yearStemIdx = ((ganzhiYear - 4) % 10 + 10) % 10;
    var stemIdx = (D.tigerStemIndex(yearStemIdx) + branchIdx) % 10;
    return { stem: D.STEMS[stemIdx], branch: MONTH_BRANCH_ORDER[branchIdx] };
  }

  /** 일지가 속한 삼합국 */
  function groupOf(branch) {
    for (var i = 0; i < D.THREE_HARMONY.length; i++) {
      if (D.THREE_HARMONY[i].branches.indexOf(branch) !== -1) return D.THREE_HARMONY[i];
    }
    return null;
  }

  /** 도화(年殺) — 일지가 속한 삼합국의 왕지로 정해진다 */
  function peachBranchOf(dayBranch) {
    var g = groupOf(dayBranch);
    return g ? (D.PEACH_OF_GROUP[g.king] || '') : '';
  }

  /**
   * 유월지 ↔ 일지 관계로 키워드를 정한다. 위에서부터 첫 매칭 하나만 쓴다.
   * 두 글자 비교라 三合(세 글자)은 성립할 수 없다.
   * 왕지가 낀 조합만 半三合(機遇)으로 보고, 生地+庫地는 拱合(甜蜜)으로 낮춰 본다.
   * 조건 12개가 키워드 12개와 1:1로 대응한다 — 문장 뱅크에 죽는 칸이 없어야 한다.
   */
  function monthKeyword(mp, ctx) {
    var mb = mp.branch;
    var db = ctx.dayBranch;
    if (!db) return '深化';

    var key = D.pairKey(mb, db);
    var g = groupOf(db);
    var sameGroup = !!(g && g.branches.indexOf(mb) !== -1 && mb !== db);

    if (ctx.peach && mb === ctx.peach) return '桃花';
    if (sameGroup && (mb === g.king || db === g.king)) return '機遇';
    if (D.SIX_HARMONY[key]) return '圓滿';
    if (isSpouseStar(mp.stem, ctx)) return '告白';
    if (sameGroup) return '甜蜜';
    if (ctx.luckBranch && mb === ctx.luckBranch) return '重逢';
    if (D.HIDDEN_HARMONY[key]) return '曖昧';
    if (mb === db) return D.SELF_PUNISH[mb] ? '注意' : '穩定';
    if (D.CLASH[key]) return '波動';
    if (D.PUNISH[key] || D.HARM[key]) return '注意';
    if (D.BREAK[key] || D.WONJIN[key]) return '獨處';
    return '深化';
  }

  /** 유월 천간이 배우자성인가 — 여자는 官殺(剋我), 남자는 財(我剋) */
  function isSpouseStar(monthStem, ctx) {
    var mElem = D.STEM_ELEMENT[monthStem];
    if (!mElem || !ctx.dayElem) return false;
    return ctx.isFemale
      ? D.CONTROLS[mElem] === ctx.dayElem
      : D.CONTROLS[ctx.dayElem] === mElem;
  }

  /**
   * 문장 뱅크에서 하나를 고른다.
   * 연·월 + 일주로 씨앗을 만들어, 같은 사람은 항상 같은 문장이 나오면서
   * 같은 달이 걸린 다른 사람과는 다른 문장이 나오게 한다.
   */
  function pickLine(keyword, year, month, seed) {
    var lines = D.MONTHLY_LINES[keyword] || [];
    if (!lines.length) return '';
    return lines[(year * 100 + month + (seed || 0)) % lines.length];
  }

  /**
   * 문자열 → 잘 섞인 정수 (FNV-1a).
   * ⚠️ 단순 코드값 합을 쓰면 안 된다. 한자 코드가 몰려 있어서
   *    뱅크 크기(4)로 나눈 나머지가 한쪽으로 쏠려 사람이 달라도 같은 문장이 나온다.
   */
  function charSum(str) {
    var h = 2166136261;
    for (var i = 0; i < str.length; i++) {
      h ^= str.charCodeAt(i);
      h = Math.imul(h, 16777619) >>> 0;
    }
    // 마무리 섞기 — 이걸 빼면 하위 비트가 몰려 60갑자 중 대부분이 같은 문장으로 간다
    h ^= h >>> 16;
    h = Math.imul(h, 2246822507) >>> 0;
    h ^= h >>> 13;
    h = Math.imul(h, 3266489909) >>> 0;
    h ^= h >>> 16;
    return h >>> 0;
  }

  function renderConnectedCount(count) {
    var box = root.querySelector('[data-teaser-connected]');
    if (!box) return;
    clear(box);

    if (count === 0) {
      box.textContent = D.TEXT.connectedZero;
      return;
    }
    if (count === 1) {
      box.appendChild(document.createTextNode('十二個月中，只有 '));
      box.appendChild(em('1'));
      box.appendChild(document.createTextNode(' 個月姻緣見動。'));
      return;
    }
    box.appendChild(document.createTextNode('十二個月中，有 '));
    box.appendChild(em(String(count)));
    box.appendChild(document.createTextNode(' 個月姻緣見動。'));
  }

  /**
   * 카드는 항상 3장이다. 데이터가 적어도 자리를 지킨다.
   *   1번 — 가장 이른 接得上 달, 문장 전체 공개
   *   2번 — 그 다음 接得上 달, 문장 + 중간 절단 + 자물쇠
   *   3번 — 전체 잠금
   * 接得上이 0개면 1번도 키워드·하트만 남기고 본문을 잠근다.
   */
  function renderMonthCards(connected, months) {
    var box = root.querySelector('[data-teaser-months]');
    if (!box) return;
    clear(box);

    if (connected.length === 0) {
      // 接得上이 하나도 없어도 무료 구간이 비면 안 된다.
      // 가장 이른 달의 하트(강도)만 남기고 본문은 잠근다.
      box.appendChild(monthCard(months && months[0], 'muted'));
      box.appendChild(monthCard(null, 'blank'));
      box.appendChild(monthCard(null, 'blank'));
      return;
    }

    box.appendChild(monthCard(connected[0], 'open'));
    box.appendChild(connected[1] ? monthCard(connected[1], 'cut') : monthCard(null, 'blank'));
    box.appendChild(monthCard(null, 'blank'));
  }

  function monthCard(month, mode) {
    var card = el('div', 'teaser-mcard' + (mode === 'blank' ? ' teaser-mcard--blank' : ''));

    if (mode === 'blank') {
      card.appendChild(el('span', 'teaser-mcard__ghost1'));
      card.appendChild(el('span', 'teaser-mcard__ghost2'));
      return card;
    }

    // 시기는 항상 잠근다 — 연·월 모두. 하트(강도)는 공개한다.
    var head = el('div', 'teaser-mcard__head');
    var date = el('div', 'teaser-mcard__date');
    date.appendChild(makeLock('teaser-lock teaser-lock--sm'));
    date.appendChild(spanText('年'));
    date.appendChild(makeLock('teaser-lock teaser-lock--xs'));
    date.appendChild(spanText('月'));

    var stars = el('div', 'teaser-mcard__stars');
    stars.textContent = starText(month ? month.stars : 1);

    head.appendChild(date);
    head.appendChild(stars);
    card.appendChild(head);

    if (mode === 'muted') {
      // 接得上이 0개일 때 — 본문은 잠그고 무료 구간이 비지 않게 한다
      card.appendChild(el('span', 'teaser-mcard__ghost2'));
      return card;
    }

    var line = el('p', 'teaser-mcard__line');
    line.textContent = month ? month.line : '';
    card.appendChild(line);

    if (mode === 'cut') {
      card.appendChild(el('span', 'teaser-mcard__cut'));
      var icon = el('span', 'teaser-lockicon teaser-mcard__icon');
      icon.appendChild(lockSvg());
      card.appendChild(icon);
    }

    return card;
  }

  function starText(level) {
    var n = Math.max(0, Math.min(5, level));
    return new Array(n + 1).join('●') + new Array(5 - n + 1).join('○');
  }

  // ─── 시간 미제공 안내 ────────────────────────────────────────────────────

  function renderHourNotes(hourUnknown) {
    toggle('[data-teaser-hour-note]', hourUnknown);
    toggle('[data-teaser-reorder]', hourUnknown);
    if (hourUnknown) {
      setText('[data-teaser-hour-note]', D.TEXT.hourUnknownNote);
      setText('[data-teaser-reorder]', D.TEXT.reorderNote);
    }
  }

  /** 폼은 "0"~"23" 또는 "未知"를 보낸다. 숫자가 아니면 모르는 것으로 본다. */
  function isHourUnknown(raw) {
    return !/^\d{1,2}$/.test(String(raw || ''));
  }

  // ─── 결제 ────────────────────────────────────────────────────────────────

  root.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-teaser-checkout]');
    if (!btn) return;

    // 세트 이벤트 페이지가 설정돼 있으면 결제 대신 그리로 넘긴다 (연애 티저만).
    // 입력값은 넘기지 않는다 — 이벤트 페이지가 같은 teaserId 로 다시 조회한다.
    var offerUrl = root.getAttribute('data-offer-url');
    if (offerUrl && productType === 'love' && teaserId) {
      window.location.href = offerUrl + '?id=' + encodeURIComponent(teaserId);
      return;
    }
    checkout(btn);
  });

  function checkout(btn) {
    if (!variantId) {
      window.location.href = '/collections/all';
      return;
    }

    btn.disabled = true;

    // 기존 properties 를 그대로 전달하고 _teaserId 만 덧붙인다.
    // 이렇게 하면 서버의 주문 처리(processOrder)를 고치지 않아도
    // 결과지가 지금과 동일한 경로로 생성된다.
    // "_" 로 시작하는 키는 장바구니·결제창에 표시되지 않는다.
    var props = {};
    Object.keys(properties).forEach(function (key) {
      props[key] = properties[key];
    });
    props._teaserId = teaserId;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1, properties: props })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('장바구니 담기 실패: ' + r.status);
        return r.json();
      })
      .then(function () {
        window.location.href = '/checkout';
      })
      .catch(function (err) {
        console.error('[teaser] 결제 연결 실패', err);
        btn.disabled = false;
        window.location.href = '/cart';
      });
  }

  // ─── 유틸 ────────────────────────────────────────────────────────────────

  function setText(selector, text) {
    var node = root.querySelector(selector);
    if (node) node.textContent = text;
  }

  function toggle(selector, visible) {
    var node = root.querySelector(selector);
    if (node) node.hidden = !visible;
  }

  function clear(node) {
    while (node.firstChild) node.removeChild(node.firstChild);
  }

  function el(tag, className) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    return node;
  }

  function spanText(text) {
    var node = document.createElement('span');
    node.textContent = text;
    return node;
  }

  function em(text) {
    var node = document.createElement('em');
    node.textContent = text;
    return node;
  }

  function makeLock(className) {
    return el('span', className);
  }

  function lockSvg() {
    var NS = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('viewBox', '0 0 16 16');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '1.4');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    svg.setAttribute('aria-hidden', 'true');

    var rect = document.createElementNS(NS, 'rect');
    rect.setAttribute('x', '3'); rect.setAttribute('y', '7');
    rect.setAttribute('width', '10'); rect.setAttribute('height', '7');
    rect.setAttribute('rx', '1.5');

    var path = document.createElementNS(NS, 'path');
    path.setAttribute('d', 'M5.5 7V4.8a2.5 2.5 0 0 1 5 0V7');

    svg.appendChild(rect);
    svg.appendChild(path);
    return svg;
  }

  function showError() {
    hide(elLoading);
    hide(elContent);
    show(elError);
  }

  function show(node) { if (node) node.hidden = false; }
  function hide(node) { if (node) node.hidden = true; }

  // ─── 미리보기 샘플 ───────────────────────────────────────────────────────
  // 서버 배포 전에 사본 테마에서 디자인만 확인할 때 쓴다 (?preview=1).
  // 값은 시안의 예시 명반과 같다.

  function sampleData() {
    return {
      ok: true,
      status: 'ready',
      name: '陳曉彤',
      variantId: '',
      input: {
        姓名: '陳曉彤', 性別: '女', 曆法: '陽曆', 出生日期: '1997-11-21', 出生時辰: '5',
        眼形: '外雙眼皮', 眼尾: '眼尾上揚', 眉形: '彎月眉',
        鼻梁: '高挺', 鼻孔: '內藏', 唇形: '纖薄', 嘴角: '仰月'
      },
      saju: {
        pillars: {
          year:  { hanja: '丁酉', stemElement: '火', branchElement: '金', stemSipseong: '偏官' },
          month: { hanja: '己亥', stemElement: '土', branchElement: '水', stemSipseong: '偏印' },
          day:   { hanja: '辛丑', stemElement: '金', branchElement: '土', stemSipseong: '比肩' },
          hour:  { hanja: '癸卯', stemElement: '水', branchElement: '木', stemSipseong: '食神' }
        },
        fivePct: { wood: 12.5, fire: 12.5, earth: 25, metal: 25, water: 25 },
        strength: 'weak',
        yongshin: { primary: '土', secondary: '金' },
        bigLuck: [{ yearRange: '2020–2029', pillar: '丙申' }],
        sinsalPos: { year: false, month: false, day: false, hour: true },
        dohwa: { present: true, branches: ['酉'] }
      }
    };
  }
})();
